import storage from './storage';

function key(userId) {
  return userId ? `crm_trash_u${userId}` : 'crm_trash';
}

export const trashService = {
  getAll(userId) {
    return storage.get(key(userId), []);
  },

  saveAll(userId, trash) {
    storage.set(key(userId), trash);
  },
};
